import { createSimpleContext } from "@openanalyst-ai/ui/context"
import type { Session } from "@openanalyst-ai/sdk/v2/client"

export type ThreadActions = {
  isPinned: (session: Session) => boolean
  togglePinned: (session: Session) => void
  forkSession: (session: Session) => void | Promise<void>
}

export const { use: useThreadActions, provider: ThreadActionsProvider } = createSimpleContext({
  name: "ThreadActions",
  gate: false,
  init: (props: { actions: ThreadActions }) => props.actions,
})
